import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {useTranslation} from "react-i18next";

export default function ExperimentPreview(props) {
    // init internationalization
    const {t} = useTranslation();

    function getValuesArray(columnTypeName, rowIndex) {
        /**
         * Helper Method, that returns all row values by a given col type and row index
         * e.g. if you want all "feature" columns, the value would be "feature"
         * */
        return Object.entries(props.columnMapping)
            .filter(([, value]) => value.type === columnTypeName)
            .map(([key]) => props.baseData[key][rowIndex]);
    }

    return (
        <Grid container spacing={1}>
            <Grid item lg={1} xs={6}>
                {props.getKeysArray("id").length >= 1 ? (
                    <>
                        <Typography variant="h6">ID</Typography>
                        <br/>
                        <TableContainer component={Paper} sx={{
                          maxWidth: {
                            xs: "40vw",
                            lg: "25vw"
                          }
                        }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        {props.getKeysArray("id").map((columnName) => (
                                            <TableCell key={columnName}>{columnName}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.from({length: 10}, (_, i) => (
                                        <TableRow key={i}>
                                            {getValuesArray("id", i).map((columnName) => (
                                                <TableCell key={columnName}>{columnName}</TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                ) : (
                    ""
                )}
            </Grid>
            <Grid item lg={2} xs={6}>
                {props.getKeysArray("timestamp").length >= 1 ? (
                    <>
                        <Typography variant="h6">
                            {t("experimentConfigurator.TimestampTitle")}
                        </Typography>
                        <br/>
                        <TableContainer component={Paper} sx={{
                          maxWidth: {
                            xs: "40vw",
                            lg: "25vw"
                          }
                        }}>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        {props.getKeysArray("timestamp").map((columnName) => (
                                            <TableCell key={columnName}>{columnName}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.from({length: 10}, (_, j) => (
                                        <TableRow key={j}>
                                            {getValuesArray("timestamp", j).map((columnName) => (
                                                <TableCell key={`timestamp${columnName}`}>
                                                    {columnName}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                ) : (
                    ""
                )}
            </Grid>
            <Grid item lg={6} xs={12}>
                <Typography variant="h6">
                    {t("experimentConfigurator.FeaturePreviewTitle")}
                </Typography>
                <br/>
                <TableContainer component={Paper} sx={{
                          maxWidth: {
                            xs: "80vw",
                            lg: "22vw"
                          }
                        }}>
                    <Table size="small">
                        <caption>
                            {" "}
                            {props.getKeysArray("feature").length >= 1
                                ? t("experimentConfigurator.ExplainFeaturesTable")
                                : t("experimentConfigurator.NoFeatures")}
                        </caption>
                        <TableHead>
                            <TableRow>
                                {props.getKeysArray("feature").map((columnName) => (
                                    <TableCell key={`featureCol-${columnName}`}>
                                        {columnName}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.from({length: 10}, (_, i) => (
                                <TableRow key={i}>
                                    {getValuesArray("feature", i).map((rowVal, index) => (
                                        <TableCell key={`featureRow-${index}-${i}`}>
                                            {rowVal}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
            <Grid item lg={3} xs={6}>
                <Typography variant="h6">
                    {t("experimentConfigurator.TargetPreviewTitle")}
                </Typography>
                <br/>
                <TableContainer component={Paper}>
                    <Table size="small">
                        <caption>
                            {" "}
                            {props.getKeysArray("target").length >= 1
                                ? t("experimentConfigurator.ExplainTargetTable")
                                : t("experimentConfigurator.NoTarget")}
                        </caption>
                        <TableHead>
                            <TableRow>
                                {props.getKeysArray("target").map((columnName) => (
                                    <TableCell key={`targetCol-${columnName}`}>
                                        {columnName}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.from({length: 10}, (_, i) => (
                                <TableRow key={i}>
                                    {getValuesArray("target", i).map((rowVal, index) => (
                                        <TableCell key={`targetRow-${index}`}>{rowVal}</TableCell>
                                    ))}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    );
}
